// extracted by mini-css-extract-plugin
module.exports = {"Berry":"Berry_Berry__hgWd1","card1":"Berry_card1__1CuiA","card1Body":"Berry_card1Body__18faR","card1Text":"Berry_card1Text__2fOni","btnPrimary1":"Berry_btnPrimary1__1oDLG"};